import styled from 'styled-components';

import { colors, radius } from '../../../../../../styles/tokens';

export const Container = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};
  padding: 24px;
`;

export const Header = styled.button`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background: transparent;
  border: none;
  cursor: pointer;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const CountBadge = styled.span<{ empty?: boolean }>`
  min-width: 22px;
  padding: 2px 8px;
  border-radius: ${radius.full};

  font-size: 12px;
  font-weight: 700;
  text-align: center;

  background-color: ${({ empty }) =>
    empty ? colors.surfaceContainerHighest : `${colors.error}1a`};
  color: ${({ empty }) => (empty ? colors.onSurfaceVariant : colors.error)};
`;

// 5 itens visíveis (~ 5 * 36px de avatar + 4 * 20px de gap) antes de
// precisar rolar -- item 6 em diante fica só no scroll, em vez de
// esticar o card indefinidamente.
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  margin-top: 16px;
  max-height: 260px;
  overflow-y: auto;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Avatar = styled.div`
  width: 36px;
  height: 36px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  background-color: ${colors.tertiaryContainer};

  font-size: 13px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const ItemText = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.onSurface};
`;

export const ItemTime = styled.p`
  font-size: 11px;
  text-transform: uppercase;
  color: ${colors.onSurfaceVariant};
  margin-top: 4px;
`;

export const Empty = styled.p`
  margin-top: 24px;

  font-size: 13px;
  color: ${colors.onSurfaceVariant};
`;

export const NotifyButton = styled.button`
  margin-top: 24px;

  padding: 8px 16px;
  border-radius: ${radius.DEFAULT};
  border: none;
  background-color: ${colors.primary};

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onPrimary};
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
